import { Skeleton } from 'components/Skeleton';

export const TimeWindowsSkeleton = () => {
  return (
    <Skeleton
      rows={3}
      isTable={false}
      height='100px'
      padding='20px 20px 0 20px'
    />
  );
};
